"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var redux_1 = require("redux");
var connectionTestReducer_1 = require("./connectionTestReducer");
var mediaReducer_1 = require("./mediaReducer");
var metaReducer_1 = require("./metaReducer");
var eventResultsReducer_1 = require("./eventResultsReducer");
var eventSummaryReducer_1 = require("./eventSummaryReducer");
var individualResultReducer_1 = require("./individualResultReducer");
var rootReducer = redux_1.combineReducers({
    connection: connectionTestReducer_1.default,
    eventResults: eventResultsReducer_1.eventResultsReducer,
    eventSummary: eventSummaryReducer_1.eventSummaryReducer,
    media: mediaReducer_1.mediaReducer,
    meta: metaReducer_1.metaReducer,
    individualResults: individualResultReducer_1.individualResultsReducer
});
exports.default = rootReducer;
//# sourceMappingURL=index.js.map


/*****************
 ** WEBPACK FOOTER
 ** ../~/athlinks-results-client/dist/src/reducers/index.js
 ** module id = 2084
 ** module chunks = 0
 **/